export const calcDate = (date1, date2) => {
  let date3 = date2 - date1;

  let days = Math.floor(date3 / (24 * 3600 * 1000))

  let leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000))

  let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000))

  let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
  let seconds = Math.round(date3 / 1000)
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  }
}

/**
 * 日期格式化
 */
export function dateFormat(date, format) {
  format = format || 'yyyy-MM-dd hh:mm:ss';
  if (date !== 'Invalid Date') {
    let o = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k] :
            ("00" + o[k]).substr(("" + o[k]).length));
    return format;
  }
  return '';

}

//字符串转日期
export function convertFromStringToDate(responseDate) {
  let dateComponents = responseDate.split(' ');
  let datePieces = dateComponents[0].split("-");
  let timePieces = dateComponents[1].split(":");
  return(new Date(datePieces[0], (datePieces[1]), datePieces[2],
                       timePieces[0], timePieces[1], timePieces[2]))
}

//字符串转年月日时分秒
export function convertFromStringToDateTime(responseDate) {
  let dateComponents = responseDate.split(' ');
  let datePieces = dateComponents[0].split("-");
  let timePieces = []
  if(dateComponents[1]){
    timePieces = dateComponents[1].split(":");
  }

  return {
    year: datePieces[0], 
    mouth: datePieces[1], 
    day: datePieces[2],
    hour: timePieces[0],
    minute: timePieces[1],
    second: timePieces[2],
  }
}